import ClientDashboardMenu from './client-dashboard-menu';

export default ClientDashboardMenu;
